// AR Tarım Mock Data

export const companyInfo = {
  name: "AR Tarım",
  tagline: "Saf Güç, Saf Kalite",
  heroHeadline: "Et Üretiminde Saf Güç",
  heroSubheadline: "Ezine'den profesyonel et işleyicilerine güvenilir sığır eti tedariki",
  location: "Ezine, Üvecik, Türkiye",
  phone: "+90 532 377 11 75",
  whatsapp: "https://wa.me/905323771175",
  email: "info@artarim.com",
  logo: "https://customer-assets.emergentagent.com/job_759616ad-7f26-4bf3-95a2-b0bcb2d45565/artifacts/4d852qxd_Ar%20Tarim%20Logo.png",
  farmImage: "https://customer-assets.emergentagent.com/job_759616ad-7f26-4bf3-95a2-b0bcb2d45565/artifacts/f9wajjnd_Screenshot%202024-02-16%20at%2011.54.58%E2%80%AFPM.png",
  youtubeVideo: "https://www.youtube.com/embed/YS-C5JXiCdk",
  mapCoordinates: {
    lat: 39.7667,
    lng: 26.3333
  }
};

export const aboutContent = {
  title: "AR Tarım Hakkında",
  subtitle: "Güven ve Kalite",
  story: `AR Tarım, Çanakkale'nin Ezine ilçesinde, Üvecik köyünde kurulmuş profesyonel bir besi çiftliğidir. "AR" ismimiz, Türkçe'deki "Ak" kelimesinden ilham alır - saflığı, güveni ve kaliteyi simgeler.

Yıllardır sürdürdüğümüz disiplinli ve sistematik yaklaşımımızla, et işleme tesislerine ve kesimhanelere tutarlı kalitede sığır eti tedarik etmekteyiz. İş ortaklarımızla kurduğumuz uzun vadeli ilişkiler, karşılıklı güven ve şeffaflık üzerine inşa edilmiştir.`,
  values: [
    {
      title: "Saflık",
      description: "Üretimimizin her aşamasında saflık ve şeffaflık ilkesiyle hareket ediyoruz."
    },
    {
      title: "Disiplin",
      description: "Sistematik ve kontrollü yetiştirme süreçleriyle tutarlı kalite sağlıyoruz."
    },
    {
      title: "Güven",
      description: "Uzun vadeli iş ortaklıkları için güvenilir bir tedarikçi olarak konumlandık."
    }
  ]
};

export const operationsData = {
  title: "Operasyonlarımız",
  subtitle: "Profesyonel Besi Çiftliği Yönetimi",
  sections: [
    {
      id: "sourcing",
      title: "Hayvan Temini",
      description: "Yüksek genetik potansiyele sahip besi danalarını güvenilir kaynaklardan temin ediyoruz. Her hayvan, çiftliğimize kabul edilmeden önce detaylı sağlık kontrolünden geçirilir.",
      icon: "Search"
    },
    {
      id: "feeding",
      title: "Besleme & Rasyon Kontrolü",
      description: "Bilimsel temelli rasyon programları ile hayvanlarımızın optimum gelişimini sağlıyoruz. Yem kalitesi ve beslenme düzeni sürekli izlenir.",
      icon: "Wheat"
    },
    {
      id: "health",
      title: "Sağlık Yönetimi",
      description: "Veteriner hekimlerimiz tarafından düzenli sağlık kontrolleri yapılır. Hastalık önleme ve erken müdahale protokolleri uygulanır.",
      icon: "Heart"
    },
    {
      id: "scale",
      title: "Üretim Kapasitesi",
      description: "Modern tesislerimizde yılda yüzlerce baş sığır besleyerek, iş ortaklarımızın taleplerini karşılayabilecek kapasiteye sahibiz.",
      icon: "TrendingUp"
    }
  ]
};

export const qualityData = {
  title: "Kalite & Standartlar",
  subtitle: "Güvenilir Et Üretimi",
  standards: [
    {
      title: "İzlenebilirlik",
      description: "Her hayvanın geçmişi, sağlık kayıtları ve besleme programı detaylı şekilde kayıt altına alınır. Tam şeffaflık sağlanır.",
      icon: "FileSearch"
    },
    {
      title: "Hayvan Refahı",
      description: "Hayvanlarımız geniş ve temiz barınaklarda, stressiz bir ortamda yetiştirilir. Refah standartları titizlikle uygulanır.",
      icon: "Shield"
    },
    {
      title: "Kalite Tutarlılığı",
      description: "Standart besleme ve yetiştirme protokolleri ile her sevkiyatta aynı kaliteyi garanti ediyoruz.",
      icon: "Award"
    }
  ]
};

export const galleryData = {
  title: "Galeri",
  subtitle: "Çiftliğimizden Kareler",
  images: [
    {
      src: "/images/farm-aerial.png",
      alt: "AR Tarım Çiftlik Havadan Görünüm",
      caption: "Ezine, Üvecik'teki tesislerimiz"
    },
    {
      src: "/images/cattle-feeding-1.jpeg",
      alt: "Besi Sığırları Besleme",
      caption: "Besi Operasyonları"
    },
    {
      src: "/images/cattle-feeding-2.jpeg",
      alt: "Hayvan Sağlığı ve Bakım",
      caption: "Hayvan Sağlığı"
    },
    {
      src: "/images/quality.png",
      alt: "Kalite Kontrol ve Veteriner Hizmetleri",
      caption: "Kalite Kontrol"
    }
  ]
};

export const contactData = {
  title: "İletişim",
  subtitle: "İş Birliği İçin Bize Ulaşın",
  address: {
    line1: "Üvecik Köyü",
    line2: "Ezine, Çanakkale",
    country: "Türkiye"
  },
  phone: "+90 532 377 11 75",
  whatsapp: "https://wa.me/905323771175",
  email: "info@artarim.com",
  forwardEmail: "fatih_balta@yahoo.com",
  formFields: [
    { name: "company", label: "Firma Adı", type: "text", required: true },
    { name: "name", label: "Ad Soyad", type: "text", required: true },
    { name: "email", label: "E-posta", type: "email", required: true },
    { name: "phone", label: "Telefon", type: "tel", required: false },
    { name: "message", label: "Mesajınız", type: "textarea", required: true }
  ]
};

export const navigationLinks = [
  { href: "#home", label: "Ana Sayfa" },
  { href: "#about", label: "Hakkımızda" },
  { href: "#operations", label: "Operasyonlar" },
  { href: "#quality", label: "Kalite" },
  { href: "#gallery", label: "Galeri" },
  { href: "#contact", label: "İletişim" }
];
